// extracted by mini-css-extract-plugin
export default {"hero":"NewsPage_hero__PeDON","hero__title":"NewsPage_hero__title__c0Im+","hero__bg":"NewsPage_hero__bg__HfYMZ","hero__ruby":"NewsPage_hero__ruby__MSjdn"};